import {useRequiredConfig} from '@domain/shifthandover'
import {
  CustomRepetitionEndOptions,
  CustomRepetitionEndsAfterRepetitions
} from '@hconnect/common/components/repetitiveTask'
import {CustomTaskRepetition} from '@hconnect/common/types'
import {useUpmPlantTimezone, useUpmPlantNow} from '@hconnect/upm'
import {Box} from '@mui/material'
import {isArray} from 'lodash'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ShiftPicker} from '../dateTimeAndShift/ShiftPicker'

type Props = {
  plantId: string
  settings: CustomTaskRepetition
  onChange: (next: CustomTaskRepetition) => void
}

export const TaskRepetitionEndingOptions: React.FC<Props> = ({plantId, settings, onChange}) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {shifts} = useRequiredConfig(plantId)
  const getPlantNow = useUpmPlantNow(plantId)
  const defaultEnd = getPlantNow().endOf('day').toISOString()
  const {t} = useTranslation()

  return (
    <>
      <CustomRepetitionEndOptions
        t={t}
        hasEndDate={!!settings.endDate}
        hasEndsAfterRepetitions={!!settings.endsAfterRepetitions}
        onChange={(next) => {
          const result: CustomTaskRepetition = {...settings}

          delete result.endsAfterRepetitions
          delete result.endDate

          if (next === 'afterCount' && !settings.endsAfterRepetitions) {
            result.endsAfterRepetitions = 2
          }
          if (next === 'onDate' && !settings.endDate) {
            result.endDate = defaultEnd ? moment.tz(defaultEnd, timezone) : undefined
          }

          onChange(result)
        }}
      />
      {settings.endDate && (
        <Box component={'span'} mx={2}>
          <ShiftPicker
            plantId={plantId}
            shifts={shifts}
            localDate={settings.endDate}
            onChange={(nextShift) => {
              if (isArray(nextShift)) return
              const next = {
                ...settings,
                endDate: nextShift.endDate ? moment.tz(nextShift.endDate, timezone) : undefined
              }
              delete next.endsAfterRepetitions
              onChange(next)
            }}
          />
        </Box>
      )}
      <CustomRepetitionEndsAfterRepetitions
        t={t}
        value={settings.endsAfterRepetitions}
        onChange={(endsAfterRepetitions) => {
          const next = {...settings}
          delete next.endDate
          next.endsAfterRepetitions = endsAfterRepetitions
          onChange(next)
        }}
      />
    </>
  )
}
